<kendo-dropdownbutton [svgIcon]="bellIcon"
  [data]="alertNotificationsList"
  (itemClick)="onDropdownButtonClick($event)"
  style="color: #fff; border-radius: 50%; padding-top: 16px"
  fillMode="link"
  themeColor="none"
  size="none"
  [popupSettings]="{ popupClass: 'notification-popup', animate: true }"
                      title="You have {{
    noNotificationFlag ? 0 : alertNotificationsList?.length
  }} unread notification(s)"
  #notificationDropdown>
  @if (
    alertNotificationsList !== undefined &&
    alertNotificationsList.length &&
    alertNotificationsList[0]?.requestId !== -1
    ) {
    <span
    class="red-dot"></span>
  }
  <ng-template kendoDropDownButtonItemTemplate let-notification>
    @if (notification.requestId !== -1) {
      <div
        class="notification-item"
        (click)="$event.stopPropagation()">
        <button kendoButton
          look="clear"
          (click)="removeNotification(notification.alertNotificationId)"
          class="icon-button">
          <kendo-svg-icon [icon]="closeIcon"
            style="color: rgb(117, 117, 117)"
          title="Dismiss / Mark as Read"></kendo-svg-icon>
        </button>
        @if (notification?.notificationType == 'New Request') {
          <span class="message"
            title="Details for Request: {{ notification?.requestId }}">
            {{ notification?.requestType }} request is Pending for your action
            &nbsp;<kendo-svg-icon [icon]="PendingNotification"
          themeColor="warning"></kendo-svg-icon>
        </span>
      }
      @if (notification?.notificationType == 'Request Approved') {
        <span class="message"
          title="Details for Request: {{ notification?.requestId }}">
          {{ notification?.requestType }} request has been Approved
          &nbsp;<kendo-svg-icon [icon]="ApprovedNotification"
        themeColor="success"></kendo-svg-icon>
      </span>
    }
    @if (notification?.notificationType == 'Request Rejected') {
      <span class="message"
        title="Details for Request: {{ notification?.requestId }}">
        {{ notification?.requestType }} request has been Rejected
        &nbsp;<kendo-svg-icon [icon]="RejectedNotification"
      themeColor="error"></kendo-svg-icon>
    </span>
  }
  @if (notification?.notificationType == 'Request Completed') {
    <span class="message"
      title="Details for Request: {{ notification?.requestId }}">
      {{ notification?.requestType }} request has been successfully Completed
      &nbsp;<kendo-svg-icon [icon]="CompletedNotification"
    themeColor="success"></kendo-svg-icon>
  </span>
}
<!-- Logic to prevent unauthorised access -->
<button kendoButton
  look="clear"
  class="icon-button"
  imageUrl="../../../../assets/images/arrow-60-right.svg"
  title="View Item"
  style="cursor: pointer"
(click)="onEngagementRequestCellClick(notification)"></button>
</div>
}
@if (notification.requestId === -1) {
  <div
    class="no-notifications notification-item"
    (click)="$event.stopPropagation()">
    <button kendoButton look="clear" class="icon-button" style="color: gray">
      <kendo-svg-icon [icon]="emptyNotification"></kendo-svg-icon>
    </button>
    <span class="message"> You have no new pending notification(s) </span>
  </div>
}
</ng-template>
</kendo-dropdownbutton>

<app-request-engagement-activity-panel [openRequestEngagementPopup]="isEngagementRequestPopupOpen"
  [engagementDetail]="selectedEngagementDetail"
  [selectedRequestId]="selectedRequestId"
  (closeEvent)="onEngagementRequestPopupClose()"
  [anchor]="anchor"
  [requestStatus]="requestStatus"
  [isApprovalUser]="isApprovalUser">
</app-request-engagement-activity-panel>

<app-request-module-activity-panel [openRequestModulePopup]="isModuleRequestPopupOpen"
  [moduleRequestDetail]="selectedModuleDetail"
  [selectedRequestId]="selectedRequestId"
  (closeEvent)="onModuleRequestPopupClose()"
  [requestStatus]="requestStatus"
  [anchor]="anchor"
  [isApprovalUser]="isApprovalUser">
</app-request-module-activity-panel>

<app-request-add-user-activity-panel [openUserAddPopup]="isUserAddRequestPopupOpen"
  [userDetail]="userAddDetails"
  [selectedRequestId]="selectedRequestId"
  (closeEvent)="onUserAddRequestPopupClose()"
  [requestStatus]="requestStatus"
  [anchor]="anchor"
  [isApprovalUser]="isApprovalUser">
</app-request-add-user-activity-panel>

<app-request-remove-user-activity-panel [openUserRemovePopup]="isUserRemovePopupOpen"
  [removeUserData]="selectedRemovalUserData"
  [selectedRequestId]="selectedRequestId"
  (closeEvent)="closeRemoveUserPopup()"
  [requestStatus]="requestStatus"
  [anchor]="anchor"
  [isApprovalUser]="isApprovalUser">
</app-request-remove-user-activity-panel>

<span #anchor class="anchor"></span>
